import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ScheduleAdapter } from 'app/core/adapters/schedule.adapter';
import { Schedule, ScheduleAPIResponse, scheduleI } from 'app/core/interfaces/schedule';
import { environment } from 'app/environments/environment';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScheduleService {


  constructor(private http: HttpClient, private scheduleAdapter: ScheduleAdapter) { }


  private getHeaders(): HttpHeaders {
    const token = localStorage.getItem('userTokenId');
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
  }


  public create(params : any) {
    return this.http.post(`${environment.apiUrl}/secretarias-schedule`, params)
  }

  public update(id: string, params: scheduleI) {
    return this.http.put(
      `${environment.apiUrl}/secretarias-schedule/${id}`,
      params,
      { headers: this.getHeaders() }
    );
  }

  public updateNew (schedule_id: string, schedule: Schedule) {
    
    const scheduleFHIR = this.scheduleAdapter.adaptToAPIFormat(schedule)
    
    return this.http.put<ScheduleAPIResponse>(`${environment.apiUrl}/secretarias-schedule/${schedule_id}`, scheduleFHIR)
      .pipe(
        map((schedule: ScheduleAPIResponse) => this.scheduleAdapter.adapterToModel(schedule))
      );
  }

  public delete (id: string) {
    return this.http.delete(`${environment.apiUrl}/secretarias-schedule/${id}`)
  }

  public show(id: string) {
    return this.http.get<Schedule>(
      `${environment.apiUrl}/secretarias-schedule/${id}`,
      { headers: this.getHeaders() }
    );
  }

  public list() {
    return (
      this.http.get(`${environment.apiUrl}/secretarias-schedule`),
      { headers: this.getHeaders() }
    );
  }

  public listNew(): Observable<Schedule[]> {
    return this.http.get<ScheduleAPIResponse[]>(`${environment.apiUrl}/secretarias-schedule`)
      .pipe(
        map((schedule: ScheduleAPIResponse[]) => 
          schedule.map((item: ScheduleAPIResponse) => this.scheduleAdapter.adapterToModel(item)))
      );
  }

  public listBySecretary(secretary_id: string) {
    return this.http.get(
      `${environment.apiUrl}/secretarias-schedule/secretaries/${secretary_id}`,
      { headers: this.getHeaders() }
    );
  }

  public listBySecretaryNew(secretary_id: string): Observable<Schedule[]> {
    return this.http.get<ScheduleAPIResponse[]>(`${environment.apiUrl}/secretarias-schedule/secretaries/${secretary_id}`)
    .pipe(
      map((schedule: ScheduleAPIResponse[]) => 
        schedule.map((item: ScheduleAPIResponse) => this.scheduleAdapter.adapterToModel(item)))
    );
  }

  public listByPractitioner(practitioner_id: string) {
    return this.http.get(
      `${environment.apiUrl}/secretarias-schedule/practitioners/${practitioner_id}`,
      { headers: this.getHeaders() }
    );
  }

  public listByPractitionerNew(practitioner_id: string): Observable<Schedule[]> {
    return this.http.get<ScheduleAPIResponse[]>(`${environment.apiUrl}/secretarias-schedule/practitioners/${practitioner_id}`)
    .pipe(
      map((schedule: ScheduleAPIResponse[]) => 
        schedule.map((item: ScheduleAPIResponse) => this.scheduleAdapter.adapterToModel(item)))
    );
  }

  public listByOrganization(organization_id: string) {

    return this.http.get(`${environment.apiUrl}/secretarias-schedule/organizations/${organization_id}`)
  }


  public listByOrganizationNew(organization_id: string): Observable<Schedule[]> {

    return this.http.get<ScheduleAPIResponse[]>(`${environment.apiUrl}/secretarias-schedule/organizations/${organization_id}`)
      .pipe(
        map((schedule: ScheduleAPIResponse[]) => 
          schedule.map((item: ScheduleAPIResponse) => this.scheduleAdapter.adapterToModel(item)))
      );
 

  }

  public listByPatient(patient_id: string) {
    return this.http.get(
      `${environment.apiUrl}/secretarias-schedule/patients/${patient_id}`,
      { headers: this.getHeaders() }
    );
  }

  public listByPatientNew(patient_id: string): Observable<Schedule[]> {

    return this.http.get<ScheduleAPIResponse[]>(`${environment.apiUrl}/secretarias-schedule/patients/${patient_id}`)
    .pipe(
      map((schedule: ScheduleAPIResponse[]) => 
        schedule.map((item: ScheduleAPIResponse) => this.scheduleAdapter.adapterToModel(item)))
    );
 
    
  



  }

}
